import React from "react";

// Banner da campanha. Com videoUrl (banner cadastrado como vídeo MP4) toca o
// vídeo mudo e em loop, com a imagem de fallback como poster; fica só a imagem
// quando o visitante pede menos movimento, está em economia de dados, o
// navegador não toca MP4 ou o vídeo falha.
function canPlayVideo() {
  if (typeof window === "undefined" || typeof document === "undefined") return false;
  if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return false;
  if (navigator.connection && navigator.connection.saveData) return false;
  const probe = document.createElement("video");
  return Boolean(probe.canPlayType && probe.canPlayType("video/mp4"));
}

export default function PictureBanner({ avifUrl, webpUrl, fallbackUrl, videoUrl, alt = "", style, className }) {
  const [videoFailed, setVideoFailed] = React.useState(false);
  const videoRef = React.useRef(null);
  const showVideo = Boolean(videoUrl) && !videoFailed && canPlayVideo();

  // Autoplay só é liberado para vídeo mudo. `muted`/`autoPlay` como props do
  // React 16 disparam um aviso de render (volumechange durante o commit) e não
  // garantem o atributo no DOM — por isso mudo e play são feitos aqui.
  React.useEffect(() => {
    const video = videoRef.current;
    if (!showVideo || !video) return;
    video.muted = true;
    const playing = video.play();
    if (playing && playing.catch) playing.catch(() => {});
  }, [showVideo, videoUrl]);

  if (showVideo) {
    return (
      <video
        ref={videoRef}
        src={videoUrl}
        poster={webpUrl || fallbackUrl}
        loop
        playsInline
        preload="metadata"
        aria-label={alt || undefined}
        style={style}
        className={className}
        onError={() => setVideoFailed(true)}
      />
    );
  }

  return (
    <picture>
      {avifUrl && <source srcSet={avifUrl} type="image/avif" />}
      {webpUrl && <source srcSet={webpUrl} type="image/webp" />}
      <img src={fallbackUrl} alt={alt} style={style} className={className} />
    </picture>
  );
}
